/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function SocialMediaIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-social-media">
        <g id="icon-legal and finance copy">
          <g id="Group 58 Copy 2">
            <g id="icon-journey-course">
              <circle
                id="Oval"
                cx="78.5"
                cy="78.5"
                r="77.5"
                fill={mainColor}
                stroke="white"
                stroke-width="2"
              />
            </g>
          </g>
        </g>
        <g id="business-affiliate-network copy">
          <path
            id="Path"
            d="M66.4783 63.3654L60.4028 57.9976C61.1105 56.7957 61.5482 55.4348 61.5482 53.9667C61.5482 49.3141 57.5171 45.5455 52.5382 45.5455C47.5593 45.5455 43.5217 49.3121 43.5217 53.9667C43.5217 58.6214 47.5593 62.3919 52.5382 62.3919C54.2934 62.3919 55.9169 61.9032 57.3024 61.0927L63.3694 66.4546C64.2874 65.3202 65.3222 64.2812 66.4783 63.3654Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M91.1541 62.2727L99.0516 49.5325C99.8291 49.7458 100.636 49.8992 101.482 49.8992C106.361 49.8992 110.304 46.1168 110.304 41.4476C110.304 36.7804 106.361 33 101.482 33C96.611 33 92.6696 36.7784 92.6696 41.4476C92.6696 43.7653 93.6446 45.8598 95.2203 47.3883L87.3478 60.0926C88.7011 60.6805 89.9775 61.4138 91.1541 62.2727Z"
            fill={secondaryColor}
          />
          <path
            id="Path_3"
            d="M118.602 74.8182C114.987 74.8182 111.926 77.1052 110.739 80.294L100.28 79.2659C100.28 79.3448 100.292 79.4198 100.292 79.4968C100.292 80.8544 100.141 82.1804 99.8696 83.461L110.325 84.4891C110.957 88.483 114.411 91.5454 118.602 91.5454C123.243 91.5454 127 87.8042 127 83.1828C127 78.5634 123.243 74.8182 118.602 74.8182Z"
            fill={secondaryColor}
          />
          <path
            id="Path_4"
            d="M87.6028 108.107L85.2798 97.8182C83.9687 98.2812 82.6045 98.6124 81.1812 98.7781L83.5081 109.069C80.8406 110.484 79 113.28 79 116.545C79 121.218 82.7325 125 87.3527 125C91.9632 125 95.6956 121.216 95.6956 116.545C95.7015 111.957 92.0951 108.243 87.6028 108.107Z"
            fill={secondaryColor}
          />
          <path
            id="Path_5"
            d="M60.8768 83.1818L47.2047 87.9122C45.6273 85.4234 42.9116 83.7728 39.8213 83.7728C34.9456 83.7728 31 87.8498 31 92.8832C31 97.923 34.9456 102 39.8213 102C44.6929 102 48.6489 97.923 48.6489 92.8832C48.6489 92.6726 48.6052 92.4792 48.5885 92.2728L62.3043 87.5296C61.6863 86.152 61.1952 84.7013 60.8768 83.1818Z"
            fill={secondaryColor}
          />
          <ellipse
            id="Oval_2"
            cx="79.0001"
            cy="79"
            rx="14.6087"
            ry="14.6364"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}
SocialMediaIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
SocialMediaIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(SocialMediaIcon);
memoized.displayName = 'SocialMediaIcon';
export default memoized;
